const BOUNDARY_NAME = 'Boundaries';
const BoundaryCheck = (value) => {
  if (value === 'Boundary Datasets') return BOUNDARY_NAME;
  return value;
};
export { BOUNDARY_NAME, BoundaryCheck };
